import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout, LocaleProvider } from "antd";
import { IntlProvider } from "react-intl";
import { Debounce } from "react-throttle";
import WindowResizeListener from "react-window-size-listener";
import { ThemeProvider } from "styled-components";
import authAction from "../../customApp/redux/auth/actions";
import appActions from "../../redux/app/actions";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import ThemeSwitcher from "../../containers/ThemeSwitcher";
import AppRouter from "./AppRouter";
import { siteConfig } from "../../settings";
import { AppLocale } from "../../dashApp";
import themes from "../../settings/themes";
import AppHolder from "./commonStyle";
import "./global.css";
import GlobalNotificationHandler from "../../customApp/components/notification/GlobalNotificationHandler";
import PoweredByAceAgeLogo from '../../image/PoweredByAceAge_240px.png';
import Autologout from "../../components/Inactive/Autologout.js";

const { Content, Footer } = Layout;
const { logout } = authAction;
const { toggleAll, changeCurrent } = appActions;
export class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            availableMenus: [],
        }
    }

    addMenu = (menu) => {
        const menus = this.state.availableMenus;
        menus.push(menu);
        this.setState({ availableMenus: menus });
    };

    componentDidMount() {
        const { user } = this.props.auth;
        if (!this.props.current || this.props.current.length === 0) {
            const key = "";
            this.props.changeCurrent([key]);
            this.props.history.push("/dashboard/" + key);
        }
        window.FreshworksWidget("show");
        window.FreshworksWidget("identify", "ticketForm", {
            name: `${user.firstName} ${user.lastName}`,
            email: `${user.email}`,
        });
    }

    componentWillUnmount() {
        window.FreshworksWidget("hide");
        window.FreshworksWidget("clear", "ticketForm");
        window.FreshworksWidget("identify", "ticketForm", {
            name: "",
            email: "",
        })
    }

    render() {
        const { url } = this.props.match;
        const { locale, selectedTheme, height, admin, userPermissions } = this.props;
        const currentAppLocale = AppLocale[locale];
        const appHeight = window.innerHeight;
        return (
            <LocaleProvider locale={currentAppLocale.antd}>
                <IntlProvider
                    locale={currentAppLocale.locale}
                    messages={currentAppLocale.messages}
                >
                    <ThemeProvider theme={themes[selectedTheme]}>
                        <AppHolder>
                            <Layout style={{ height: appHeight }}>
                                <Autologout />
                                <Debounce time="1000" handler="onResize">
                                    <WindowResizeListener
                                        onResize={windowSize =>
                                            this.props.toggleAll(
                                                windowSize.windowWidth,
                                                windowSize.windowHeight
                                            )
                                        }
                                    />
                                </Debounce>
                                <Topbar url={url} />
                                <GlobalNotificationHandler />
                                <Layout style={{ flexDirection: "row", overflowX: "hidden" }}>
                                    <Sidebar url={url} addMenu={this.addMenu} />
                                    <Layout
                                        className="isoContentMainLayout"
                                        style={{
                                            height: height
                                        }}
                                    >
                                        <Content
                                            className="isomorphicContent"
                                            style={{
                                                padding: "70px 0 0",
                                                flexShrink: "0",
                                                background: "#f1f3f6",
                                                position: "relative"
                                            }}
                                        >
                                            <AppRouter url={url} admin={admin} userPermissions={userPermissions} />
                                        </Content>
                                        <Footer
                                            style={{
                                                background: "#ffffff",
                                                textAlign: "center",
                                                borderTop: "1px solid #ededed"
                                            }}
                                        >
                                            <img alt="Powered by AceAge" src={PoweredByAceAgeLogo} width="125" style={{ marginRight: 24 }}/>
                                            {siteConfig.footerText}
                                        </Footer>
                                    </Layout>
                                </Layout>
                                <ThemeSwitcher />
                            </Layout>
                        </AppHolder>
                    </ThemeProvider>
                </IntlProvider>
            </LocaleProvider>
        );
    }
}

export default connect(
    state => ({
        auth: state.Auth,
        locale: state.LanguageSwitcher.language.locale,
        selectedTheme: state.ThemeSwitcher.changeThemes.themeName,
        height: state.App.height,
        current: state.App.current,
        admin: state.Auth.user && state.Auth.user.isSuperAdmin,
        userPermissions: state.Auth.user && state.Auth.user.permissions,
    }),
    { logout, toggleAll, changeCurrent }
)(App);
